var cubeCssRendererStatic = {
	front: "",
	back: "2"
};

function cubeCssRenderer(id,props, half) {
	this.ident = id;
	this.properties = props;
	this.paused = false;
	this.loaded = {a:0, b:0, c:0, d:0, e:0, f:0};
	this.wfix = false;
	this.wfixname = "";

	if (this.detectMobile()) {
		this.wfix = true;
		this.wfixname = "wfixmobile";
		cubeCssRendererStatic.sd = 1280;
//		cubeCssRendererStatic.sd = 1480;
//		this.planeWidth = 960; // 760
		this.planeWidth = 960; // 760
		this.halfimage = 470; // 380
		this.halfimage2 = 940; // 760
	} else {
//		cubeCssRendererStatic.sd = 1680;
		cubeCssRendererStatic.sd = Quality != undefined ? Quality.current:2048;
		if (navigator.userAgent.match(/webkit/i) != null) {
			
			this.wfix = true;
			this.wfixname = "wfix";
			
			this.planeWidth = 3100; //3002 trzeba zrobic margines dla chrome zeby wyeliminowac czarny pasek
			this.halfimage = 1500;
			this.halfimage2 = 2500;

		} else {

			this.planeWidth = 3000;
			this.halfimage = 1500;
			this.halfimage2 = 2500;

		}
	}

	cubeCssRendererStatic.ident = id;		
}

cubeCssRenderer.prototype = {
	rx: 0,
	ry: 0,
	veryHighQualityLoaded:false,
	basePerspective: 550, //tak jak perspective w css
	zoom:550, // 500 zoom powinno byc rowne perspective w css
	minZoom:450, // 550
//	minZoom:250, // 550
	maxZoom:1550, // 750
	zoomModifier:0, // modyfikacja perspektywy dla roznych ukladow ekranow - dla portrait chcemy duzo mniejszy zoom bazowy
	hqZoom:600, // 600
	zoomMultiplier:1,
	
	loadTemplate: function() {
		$("#player").html(TPL.render("panorama-template", {"w":this.planeWidth, "wfix":this.wfix, "wfixname":this.wfixname}));
	},

	reUse: function() {
		var b = cubeCssRendererStatic.back;
		cubeCssRendererStatic.back = cubeCssRendererStatic.front;
		cubeCssRendererStatic.front = b;		
	},

	build: function() {
		this.pano = new css3DNode("#pano" + cubeCssRendererStatic.front, false);

		this.a = new css3DNode("#_a" + cubeCssRendererStatic.front, true);
		this.b = new css3DNode("#_b" + cubeCssRendererStatic.front, true);
		this.c = new css3DNode("#_c" + cubeCssRendererStatic.front, true);
		this.d = new css3DNode("#_d" + cubeCssRendererStatic.front, true);
		this.e = new css3DNode("#_e" + cubeCssRendererStatic.front, true);
		this.f = new css3DNode("#_f" + cubeCssRendererStatic.front, true);
	},

	detectMobile: function() {
 		var check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
  	},

  	realZoom: function() {
  		return this.zoom;
  	},

  	setPerspective: function(v) {  		
  		//this.minZoom = v;
  		this.zoom = v;

		//this.zoom -= 250;

		this.basePerspective = this.zoom;

  		$("#player").css("perspective", this.basePerspective + "px");
  		$("#player").css("-moz-perspective", this.basePerspective + "px");
  		$("#player").css("-webkit-perspective", this.basePerspective + "px");
  	},

  	getPerspective: function() {
  		return this.basePerspective;
  	},

	load: function() {
//		this.loadQuality(764);
		this.loadQuality(256);
		player.preload(true);

		this.setPerspective(650);

		if (this.properties.show_logo == "1") {
			$("#pano" + cubeCssRendererStatic.front + " .plogo").show();
		} else {
			$("#pano" + cubeCssRendererStatic.front + " .plogo").hide();
		}
	},
	
	loadHandlers:function(img) {
		img.onloadstart = function() {
		};
		
		img.onprogrogress = function(e) {
			
		}
	},
	
	loadQuality: function(q) {
		cubeCssRendererStatic.quality1 = q;
		cubeCssRendererStatic.quality2 = q;
		cubeCssRendererStatic.quality3 = q;
		cubeCssRendererStatic.quality4 = q;
		cubeCssRendererStatic.quality5 = q;
		cubeCssRendererStatic.quality6 = q;
		
		var self =this;	
			
		var ia = new Image();
		ia.onload = function() {
			$("#ia" + cubeCssRendererStatic.front).attr('src',ia.src);
			self.loaded.a += 1;
			self.checkLoaded();
			if (player.offline) cubeCssRendererStatic.quality1 = cubeCssRendererStatic.sd;
			else if (cubeCssRendererStatic.quality1 < cubeCssRendererStatic.sd) {
				ia.src = player.offline ? "data/pano_" + cubeCssRendererStatic.ident + "_1.jpg" : player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=1";
				cubeCssRendererStatic.quality1 = cubeCssRendererStatic.sd;
			}
		};
//		ia.src = player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=1";
		ia.src = player.offline ? "data/pano_" + cubeCssRendererStatic.ident + "_1.jpg" : player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=1";
		//if (ia.complete) ia.onload();
		//$("#ia").show();
		
		//$("#_a").css("background-image", "url(" + player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=1)");
		
		
		var ib = new Image();
		ib.onload = function() {
			$("#ib" + cubeCssRendererStatic.front).attr('src',ib.src);
			self.loaded.b += 1;
			self.checkLoaded();
			if (player.offline) cubeCssRendererStatic.quality2 = cubeCssRendererStatic.sd;
			else if (cubeCssRendererStatic.quality2 < cubeCssRendererStatic.sd) {
//				ib.src = player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=2";
				ib.src = player.offline ? "data/pano_" + cubeCssRendererStatic.ident + "_2.jpg" : player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=2";
				cubeCssRendererStatic.quality2 = cubeCssRendererStatic.sd;
			}
		}
//		ib.src = player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=2";
		ib.src = player.offline ? "data/pano_" + cubeCssRendererStatic.ident + "_2.jpg" : player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=2";
		//if (ib.complete) ib.onload();
		//$("#ib").show();		
		
		//$("#_b").css("background-image", "url(" + player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=2)");
		
		
		var ic = new Image();
		ic.onload = function() {
			$("#ic" + cubeCssRendererStatic.front).attr('src',ic.src);
			self.loaded.c += 1;
			self.checkLoaded();
			if (player.offline) cubeCssRendererStatic.quality3 = cubeCssRendererStatic.sd;
			if (cubeCssRendererStatic.quality3 < cubeCssRendererStatic.sd) {
//				ic.src = player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=3";
				ic.src = player.offline ? "data/pano_" + cubeCssRendererStatic.ident + "_3.jpg" : player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=3";
				cubeCssRendererStatic.quality3 = cubeCssRendererStatic.sd;
			}
		}
//		ic.src = player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=3";
		ic.src = player.offline ? "data/pano_" + cubeCssRendererStatic.ident + "_3.jpg" : player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=3";
		//if (ic.complete) ic.onload();
		//$("#ic").show();		
		
		//$("#_c").css("background-image", "url(" + player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=3)");
		
		
		var id = new Image();
		id.onload = function() {
			$("#id" + cubeCssRendererStatic.front).attr('src',id.src);
			self.loaded.d += 1;
			self.checkLoaded();
			if (player.offline) cubeCssRendererStatic.quality4 = cubeCssRendererStatic.sd;
			else if (cubeCssRendererStatic.quality4 < cubeCssRendererStatic.sd) {
//				id.src = player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=4";
				id.src = player.offline ? "data/pano_" + cubeCssRendererStatic.ident + "_4.jpg" : player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=4";
				cubeCssRendererStatic.quality4 = cubeCssRendererStatic.sd;
			}
		}
//		id.src = player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=4";
		id.src = player.offline ? "data/pano_" + cubeCssRendererStatic.ident + "_4.jpg" : player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=4";
		//if (id.complete) id.onload();
		//$("#id").show();
		
		//$("#_d").css("background-image", "url(" + player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=4)");
		
		
		var ie = new Image();
		ie.onload = function() {
			$("#ie" + cubeCssRendererStatic.front).attr('src',ie.src);
			self.loaded.e += 1;
			self.checkLoaded();
			if (player.offline) cubeCssRendererStatic.quality5 = cubeCssRendererStatic.sd;
			else if (cubeCssRendererStatic.quality5 < cubeCssRendererStatic.sd) {
//				ie.src = player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=5";
				ie.src = player.offline ? "data/pano_" + cubeCssRendererStatic.ident + "_5.jpg" : player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=5";
				cubeCssRendererStatic.quality5 = cubeCssRendererStatic.sd;
			}
		}
//		ie.src = player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=5";
		ie.src = player.offline ? "data/pano_" + cubeCssRendererStatic.ident + "_5.jpg" : player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=5";
		//if (ie.complete) ie.onload();
		//$("#ie").show();			
		
		//$("#_e").css("background-image", "url(" + player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=5)");

		
		var iif = new Image();
		iif.onload = function() {
			self.loaded.f += 1;
			self.checkLoaded();
			$("#if" + cubeCssRendererStatic.front).attr('src',iif.src);
			if (player.offline) cubeCssRendererStatic.quality6 = cubeCssRendererStatic.sd;
			if (cubeCssRendererStatic.quality6 < cubeCssRendererStatic.sd) {
//				iif.src = player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=6";
				iif.src = player.offline ? "data/pano_" + cubeCssRendererStatic.ident + "_6.jpg" : player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=6";
				cubeCssRendererStatic.quality6 = cubeCssRendererStatic.sd;
			}
		}
//		iif.src = player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=6";
		iif.src = player.offline ? "data/pano_" + cubeCssRendererStatic.ident + "_6.jpg" : player.storage + "/res.php?q=" + cubeCssRendererStatic.sd + "&id=" + cubeCssRendererStatic.ident + "&part=6";

		//if (iif.complete) iif.onload();
		//$("#if").show();
		
		//$("#_f").css("background-image", "url(" + player.storage + "/res.php?q=" + q + "&id=" + this.ident + "&part=6)");
	},
	
	checkLoaded: function() {
		//console.log(this.loaded);
		//console.log(this.loaded);
		if (this.loaded.a >= 1 && this.loaded.b >= 1 && this.loaded.c >= 1 && this.loaded.d >= 1 && this.loaded.e >= 1 && this.loaded.f >= 1) {
			this.loaded = {};

			player.preload(false);
			if (cubeCssRendererStatic.front == "") {
				$(".buf").show();
				$(".buf").css("opacity", 0.01);
			} else {
				$(".buf2").show()
				$(".buf").css("opacity", 0.99);
			}
			setTimeout(function() {
				if (cubeCssRendererStatic.front == "") {
					cubeCssRendererStatic.tw = new Tween(function(c) {$(".buf").css("opacity", c)}, function() { $(".buf2").hide();HotSpotManager.setVisibility(true); AppEvent.trigger(player, "PLACE.LOADED", cubeCssRendererStatic.self);});
					cubeCssRendererStatic.tw.start(0.01,1,500);
				} else {
					cubeCssRendererStatic.tw = new Tween(function(c) {$(".buf").css("opacity", c)}, function() { $(".buf").hide();HotSpotManager.setVisibility(true); AppEvent.trigger(player, "PLACE.LOADED", cubeCssRendererStatic.self);});
					cubeCssRendererStatic.tw.start(0.99,0,500);
				}
			}, 200);
		}
	},

	process: function() {
		//var tx = player._width * 0.5 - 375;
		//var ty = player._height * 0.5 - 375;
		
		$("#world").css("margin-left", -this.planeWidth + (player._width * 0.5) + "px");
		$("#world").css("margin-top", -this.planeWidth + (player._height * 0.5) + "px");
		
		var tx = this.planeWidth - this.halfimage;
		var ty = this.planeWidth - this.halfimage;
		
		var hi = 0;
		var sc = 1;
		if (cubeCssRendererStatic.front == "2") {
			hi = this.halfimage2;
			sc = this.halfimage2 / this.halfimage;
		}
		else hi = this.halfimage;

		this.pano.resetTransform();
		this.pano.translate(tx, ty, this.zoom);
		this.pano.applyTransforms();
		
		this.a.resetTransform();
		this.a.rotateX(this.ry);this.a.rotateY(this.rx);
		this.a.translate(0,0,-hi);
		this.a.scale(sc, sc, sc);
		this.a.applyTransforms();
				
		this.b.resetTransform();
		this.b.rotateX(this.ry);this.b.rotateY(this.rx);
		this.b.translate(hi,0,0);
		this.b.scale(sc, sc, sc);
		this.b.rotateY(-90);
		this.b.applyTransforms();
		
		this.c.resetTransform();
		this.c.rotateX(this.ry);this.c.rotateY(this.rx);
		this.c.translate(0,0,hi);
		this.c.scale(sc, sc, sc);
		this.c.rotateY(-180);
		this.c.applyTransforms();

		this.d.resetTransform();
		this.d.rotateX(this.ry);this.d.rotateY(this.rx);
		this.d.translate(-hi,0,0);
		this.d.scale(sc, sc, sc);
		this.d.rotateY(-270);
		this.d.applyTransforms();

		this.e.resetTransform();
		this.e.rotateX(this.ry);this.e.rotateY(this.rx);
		this.e.translate(0,-hi,0);
		this.e.scale(sc, sc, sc);
		this.e.rotateX(-90);
		this.e.applyTransforms();

		this.f.resetTransform();
		this.f.rotateX(this.ry);this.f.rotateY(this.rx);
		this.f.translate(-1,hi,0);
		this.f.scale(sc, sc, sc);
		this.f.rotateX(90);
		this.f.applyTransforms();
						
		if (this.zoom > this.hqZoom && this.veryHighQualityLoaded == false) {
			//this.loadQuality(1280);
			this.veryHighQualityLoaded = true;
		}

	},	
		
	old2angle: function(n) {
		return parseFloat(n) + 85;
//		return parseFloat(n) + (parseFloat(this.properties.properties.north) - 95) + 180;
	},

	clear: function() {
		
	},

	reorient: function() {
		
	}
}